<shared-ui-card-header
   [buttonActions]="actions"
   [subtitle]="'intermediate_report.additional_kpi_screen' | translate"
   [title]="'intermediate_report.manage_kpi' | translate"
   mat-dialog-title
></shared-ui-card-header>

<mat-dialog-content class="overflow-auto">
   <webvis-feature-secondary-kpis
      #secondaryKpisComponent
      [(kpiDialogData)]="data.kpis"
      [currentDiscipline]="data.currentDiscipline"
      [order]="data.order"
      [primaryKpi]="data.primaryKpi"
      [readonly]="data.readonly"
      [selectionOnly]="data.selectionOnly"
   ></webvis-feature-secondary-kpis>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-end">
   <button
      [mat-dialog-close]="false"
      mat-button
   >
      {{ 'general.cancel' | translate }}
   </button>
   <button
      (click)="saveKpi()"
      [disabled]="data.readonly || secondaryKpisComponent.currentHistoryIndex() === 0"
      [loading]="saving()"
      mat-flat-button
   >
      {{ 'general.save' | translate }}
   </button>
</mat-dialog-actions>
